import { render, staticRenderFns } from "./constitute.vue?vue&type=template&id=e79ad38c&"
import script from "./constitute.vue?vue&type=script&lang=ts&"
export * from "./constitute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "constitute.vue"
export default component.exports